/**
 * Rounds a given number to the specified number of decimal places.
 *
 * @param {number} x - The number to be rounded.
 * @param {number} n - The number of decimal places to round to.
 * @returns {number} The rounded number.
 */
export const round = (x: number, n: number): number => Number(Number(x).toFixed(n));
